
export class LoadAttributiLayerINModel { 
    idSchedaProgetto: number
    parentUid: number
}